import { Col, Row, Typography } from 'antd';
import React from 'react';
import { Card, Currency, Divider } from '@common/components';
import { InvoiceInstallmentFragmentType } from '@pay-bill/graphql';
import { InstallmentsCard } from './_installments-card';

const { Text } = Typography;

export const BillingSummaryCard = ({
  summaryData,
  installmentsData,
}: {
  summaryData:
    | {
        totalHours: number;
        totalCents: number;
        totalRemittanceCents: number;
        mspFeePercentage: number;
        tierFeePercentage: number;
        totalMspCents: number;
        totalTierCents: number;
      }
    | {
        totalHours: number;
        totalCents: number;
        totalRemittanceCents: undefined;
        mspFeePercentage: undefined;
        tierFeePercentage: undefined;
        totalMspCents: undefined;
        totalTierCents: undefined;
      };
  installmentsData:
    | {
        installments: InvoiceInstallmentFragmentType[];
        remainingInstallmentBalance: number;
        canCreate: { value: boolean };
        worksInvoiceId: string;
      }
    | undefined;
}) => {
  const hasMSPFee = !!summaryData.mspFeePercentage;
  const hasTierFee = !!summaryData.tierFeePercentage;
  const hasAdminFee = hasMSPFee || hasTierFee;
  const finalTotalCents = hasAdminFee
    ? summaryData.totalRemittanceCents
    : summaryData.totalCents;

  return (
    <>
      <Card title="Summary" className="billing-summary-card">
        <Row className="card-body-row" style={{ marginBottom: 12 }}>
          <Col span={12}>
            <Row>
              <Text type="secondary">Total Hours</Text>
            </Row>
          </Col>
          <Col span={11}>
            <Row justify="end">
              <Text>{summaryData.totalHours}</Text>
            </Row>
          </Col>
        </Row>

        <Row
          className="card-body-row"
          style={{ marginBottom: hasAdminFee ? 12 : 0 }}
        >
          <Col span={12}>
            <Row>
              <Text type="secondary">Labor Billings</Text>
            </Row>
          </Col>
          <Col span={11}>
            <Row justify="end">
              <Text>
                <Currency value={summaryData.totalCents / 100} />
              </Text>
            </Row>
          </Col>
        </Row>

        {hasAdminFee && (
          <Row className="card-body-row">
            <Col span={12}>
              <Row>
                <Text type="secondary">
                  Admin Fee{' '}
                  {hasTierFee
                    ? summaryData.tierFeePercentage
                    : summaryData.mspFeePercentage}
                  %
                </Text>
              </Row>
            </Col>
            <Col span={11}>
              <Row justify="end">
                <Text>
                  <Currency
                    value={
                      hasTierFee
                        ? summaryData.totalTierCents / 100
                        : summaryData.totalMspCents / 100
                    }
                  />
                </Text>
              </Row>
            </Col>
          </Row>
        )}

        <Divider gutter={12} />

        <Row
          className="card-body-row"
          style={{
            marginBottom: installmentsData ? 26 : 0,
          }}
        >
          <Col span={12}>
            <Row>
              <Text strong>Total</Text>
            </Row>
          </Col>
          <Col span={11}>
            <Row justify="end">
              <Text strong>
                <Currency value={finalTotalCents / 100} />
              </Text>
            </Row>
          </Col>
        </Row>

        {installmentsData && (
          <InstallmentsCard installmentsData={installmentsData} />
        )}
      </Card>
      <style jsx>{`
        :global(.billing-summary-card .card-body-row) {
          margin-right: 16px;
        }
      `}</style>
    </>
  );
};
